import { favLogos as fundLogos } from '../logo/logos';

export function* getNextPageGenerator({
    data,
    startIndex = 0,
    itemsPerPage = 10,
    filters = [],
}: any) {
    const end = data.length;
    let filterData: any[] = [];
    for (let i = startIndex; i < end; i++) {
        if (filterData.length === itemsPerPage) {
            let index: number = yield filterData;
            startIndex = index || startIndex;
            filterData = [];
        }
        const fund = data[i];
        let isPassed = filters.every((func: Function) => func.call({}, fund));
        if (isPassed) {
            filterData = [...filterData, { ...fund, fundLogo: getFundLogo(fund.fundAmcCode) }];
        }
    }
    return filterData;
}

export const getFundLogo = (amcCode: string) => {
    let fundCode = Object.keys(fundLogos).find((fund) => fund === amcCode);
    return fundCode ? `${fundLogos[fundCode]}.svg` : `default.svg`;
};

export function sortFunds(data: any) {
    return data.sort((a: any, b: any) => {
        const fund1: string = a.amcName?.toUpperCase();
        const fund2: string = b.amcName?.toUpperCase();
        return fund1.localeCompare(fund2);
    });
}
